
import { Component, Input, ChangeDetectorRef, OnChanges } from '@angular/core';

@Component({
    selector: 'key-video-thumbnail',
    templateUrl: './video-thumbnail.component.html',
    standalone: false
})
export class VideoThumbnailComponent implements OnChanges {

    @Input() url: string;

    imgUrl: string = 'assets/images/video-thumbnail.png';
    hasError = false;
    isVideo = false;

    constructor(private ref: ChangeDetectorRef) {
    }

    ngOnChanges() {
        this.hasError = false;
        this.isVideo = this.url.includes('.mp4') || this.url.includes('.mpg') || this.url.includes('.mpeg');
        this.imgUrl = this.url;
    }

    onEnter(_event: Event) {
        if (!this.isVideo || this.hasError) { return; }
        this.imgUrl = this.url.replace('.jpg', '.gif');
        this.ref.markForCheck();
    }
    
    onLeave(_event: Event) {
        if (!this.isVideo || this.hasError) { return; }
        this.imgUrl = this.url;
        this.ref.markForCheck();
    }

    onError(_event: Event) {
        if (this.imgUrl !== 'assets/images/video-thumbnail.png') {
            this.imgUrl = 'assets/images/video-thumbnail.png';
        }
        this.hasError = true;
        this.ref.markForCheck();
    }
}